// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .multicolumn .children {
    padding: 4px;
}

.multicolumn .children > div {
    padding: 4px;
}`, "",{"version":3,"sources":["webpack://./src/salesCore/medicalInformation/style.css"],"names":[],"mappings":";EACE;IACE,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB","sourcesContent":["\r\n  .multicolumn .children {\r\n    padding: 4px;\r\n}\r\n\r\n.multicolumn .children > div {\r\n    padding: 4px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
